import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Entity } from '../../model/entity.model';
import { OotbEntityService } from '../../services/ootb-entity.service';
import { OotbEntityComponent } from './ootb-entity/ootb-entity.component';

@Component({
    selector: 'app-ootb-entity-list',
    imports: [OotbEntityComponent, CommonModule],
    templateUrl: './ootb-entity-list.component.html'
})
export class OotbEntityListComponent {
  public createEntityFlag = false;
  public entityList: Entity[] = [];
  public newData: Entity = this.createEmptyEntity();

  constructor(private ootbEntityService: OotbEntityService) {
    this.ootbEntityService.$values.subscribe((value: Entity[] | undefined) => {
      // Hidden control entities (systemOotbTenant / systemOotbTenantInvite) never appear in the picker.
      this.entityList = (value ?? []).filter((e) => !e.hidden);
    });
    this.ootbEntityService.query(1000);
  }

  private createEmptyEntity(): Entity {
    return {
      name: '',
      type: 'TABLE',
      id: '',
      status: 'NEW',
      data: [
        {
          name: 'id',
          type: 'UUID',
          isUnique: true,
          primaryKey: true,
          startIncrementFrom: 0,
          referenceEntityName: '',
          referenceEntityColumnName: 'id',
          id: '',
          data: [],
          defaultValue: '',
        }
      ],
    };
  }

  createEntity() {
    this.newData = this.createEmptyEntity();
    this.createEntityFlag = true;
  }

  viewEntity(entity: Entity) {
    this.newData = JSON.parse(JSON.stringify(entity));
    this.createEntityFlag = true;
  }

  exitEntity() {
    this.createEntityFlag = false;
  }
}
